let img_arr = [];

export default img_arr;